import React, { FC, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PATH from '../../navigation/path'
import styles from './StaffMainInformation.module.css'
import iconEdit from '../../assets/icons/iconEdit.svg'
import InformationItem from '../InformationItem/InformationItem'
import { StaffType } from '../../redux/actions/types'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { getCurrentCompany } from '../../redux/actions/companiesAction'
import TitleBlockForEditPages from '../TitleBlockForEditPages/TitleBlockForEditPages'
import CustomButton from '../UI/CustomButton/CustomButton'
import { ItemInfo } from '../ItemInfo/ItemInfo'
import { createRoleForTable } from '../../utils/createRoleForRegister'

export type StaffMainInformationPropsType = {
  staffData: StaffType
}

const StaffMainInformation: FC<StaffMainInformationPropsType> = ({ staffData }) => {
  const { companyId } = useParams<{ companyId: string }>()
  const { workerId } = useParams<{ workerId: string }>()

  const { token, user, userRole } = useAppSelector((state) => state.auth)
  const { currentCompany } = useAppSelector((state) => state.companies)

  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const onRedirectToEditCardPage = () => {
    navigate(`${PATH.editStaffCardPage}${companyId}/${workerId}`)
  }

  const foundObject = currentCompany.employees.find((item) => item.id === user.employee?.id)

  useEffect(() => {
    dispatch(getCurrentCompany({ companyId, token }))
  }, [companyId, dispatch])

  return (
    <div className={styles.mainInformationBlock}>
      <div className={styles.header}>
        <h2 className={styles.title}>Основная информация</h2>
        {(userRole === 'superAdmin' ||
          userRole === 'admin' ||
          (userRole === 'directorPlace' && foundObject) ||
          (userRole === 'directorAgent' && foundObject)) && (
          <CustomButton
            iconSrc={iconEdit}
            className={styles.btn}
            title={''}
            onClick={onRedirectToEditCardPage}
          />
        )}
      </div>
      <div className={styles.mainInformationContainer}>
        <ItemInfo title='ФИО' value={staffData.user.fullName} />
        <ItemInfo title='Номер телефона' value={staffData.user.phone} />
        <ItemInfo title='Компания' value={staffData.company.name} />
        <ItemInfo title='Роль' value={createRoleForTable(staffData.user.role) ?? ''} />
        <ItemInfo title='Электронная почта/Логин' value={staffData.user.email} />
      </div>
    </div>
  )
}

export default StaffMainInformation
